import React, { useId } from 'react';

// Coordinates match the photograph and its object-cover crop.
const WIRELESS_PATH = 'M 836 423 Q 1023 414 1215 442';
// Leave room for the returning pulse's trailing edge and glow beside the dish.
const RETURN_PATH = 'M 1192 430 Q 1003 402 836 423';
const CABLE_PATH = 'M 1388 563 C 1388 576 1384 582 1396 586 C 1412 591 1451 581 1451 607 L 1451 659 C 1451 691 1465 714 1465 744 L 1465 956';

const HeroSignalBeam: React.FC = () => {
  const id = useId().replace(/:/g, '');
  return (
    <div className="pointer-events-none absolute inset-0 z-[1] overflow-hidden hidden md:block" aria-hidden="true">
      <svg className="h-full w-full" viewBox="0 0 1672 941" preserveAspectRatio="xMidYMid slice">
        <defs>
          <filter id={`${id}-glow`} x="-100%" y="-200%" width="300%" height="500%">
            <feGaussianBlur stdDeviation="4" />
          </filter>
          <linearGradient id={`${id}-pulse`}>
            <stop offset="0" stopColor="#168de8" stopOpacity="0" />
            <stop offset="0.45" stopColor="#38baff" stopOpacity="0.65" />
            <stop offset="0.85" stopColor="#a4e8ff" />
            <stop offset="1" stopColor="#effcff" />
          </linearGradient>
          {/* Fade both directions at the tower, including their glow, so the
              moving tails cannot cross or flash over the steady tower light. */}
          <linearGradient id={`${id}-tower-fade`} gradientUnits="userSpaceOnUse" x1="839" y1="0" x2="856" y2="0">
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <mask id={`${id}-tower-boundary`} maskUnits="userSpaceOnUse" x="836" y="370" width="430" height="130">
            <rect x="836" y="370" width="430" height="130" fill={`url(#${id}-tower-fade)`} />
          </mask>
        </defs>
        <circle cx="836" cy="423" r="7" fill="#32b6ff" filter={`url(#${id}-glow)`} />
        <circle cx="836" cy="423" r="2" fill="#d4f5ff" />
        <g mask={`url(#${id}-tower-boundary)`}>
        {[false, true].map((returning) => Array.from({ length: 5 }, (_, i) => (
          <g key={`${returning}-${i}`} className="hero-signal-flight" style={{ offsetPath: `path('${returning ? RETURN_PATH : WIRELESS_PATH}')`, animationDelay: `${-i * 0.56 - (returning ? 0.28 : 0)}s` }}>
            <g className="hero-signal-pulse" style={{ animationDelay: `${-i * 0.56 - (returning ? 0.28 : 0)}s`, animationDirection: returning ? 'reverse' : 'normal' }}>
              <rect x="-36" y="-7" width="42" height="14" rx="7" fill="#28aaff" opacity="0.85" filter={`url(#${id}-glow)`} />
              <rect x="-32" y="-4" width="36" height="8" rx="4" fill={`url(#${id}-pulse)`} />
              <rect x="-21" y="-1.2" width="24" height="2.4" rx="1.2" fill={`url(#${id}-pulse)`} />
            </g>
          </g>
        )))}
        </g>
        {/* Cable exits the lower rear housing at the dish rim, loops toward the mast, then drops over the roof. */}
        <path d={CABLE_PATH} fill="none" stroke="#080808" strokeWidth="7" strokeLinecap="round" />
        <path d={CABLE_PATH} fill="none" stroke="#262626" strokeOpacity="0.65" strokeWidth="3" />
        <g fill="none" strokeLinecap="round">
          <path d={CABLE_PATH} className="hero-cable-flow" stroke="#16aaff" strokeWidth="7" filter={`url(#${id}-glow)`} />
          <path d={CABLE_PATH} className="hero-cable-flow" stroke="#53caff" strokeWidth="2.5" />
          <path d={CABLE_PATH} className="hero-cable-flow hero-cable-core" stroke="#d7f8ff" strokeWidth="1" />
        </g>
      </svg>
    </div>
  );
};
export default HeroSignalBeam;
